<form class="composer" (ngSubmit)="submit()" (click)="focus()">
  <textarea #input
            class="composer__input"
            rows="1"
            name="prompt"
            [ngModel]="text"
            (ngModelChange)="onType($event)"
            [placeholder]="placeholder"
            [attr.aria-label]="placeholder"
            (input)="resize()"
            (keydown.enter)="onEnter($event)"></textarea>
  <div class="composer__actions">
    <button type="submit" class="composer__send" [disabled]="!canSend" aria-label="Send question" title="Send">
      <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 16V4.5M10 4.5L5 9.5M10 4.5L15 9.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
  </div>
</form>
